import { createService } from '../../api/createService';
import {
  LoqateFindRequestSchema,
  LoqateFindResponseSchema,
} from './LoqateFindService.schemas';

export default createService(
  {
    loqateFind: {
      method: 'POST',
      url: () =>
        'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      credentials: 'omit',
      requestSchema: LoqateFindRequestSchema,
      responseSchema: LoqateFindResponseSchema,
    },
  },
  undefined,
  false,
);
